import { Map as ImmutableMap } from 'immutable';
import { createAction as reduxActionsCreator } from 'redux-actions';

import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import type { TransactionRuleType } from 'app-components/flux/transaction-rules/transactionRulesTypes';
import type { TransactionRecord } from 'app-components/flux/transactions/transactionsTypes';
import { ROOT_MODAL_PRESENTATION_PROP } from 'components/Drawers/standardDrawerContract';

export const DIALOG_TYPE = 'TRANSACTION_RULE_DIALOG';

export const TransactionRuleAction = reduxActionsCreator(
  rootUiActions.createDialog.toString(),
  ({
    id,
    transaction,
    rule,
    handleClose,
    isDrawerOverlay,
    originalIsReviewed,
  }: {
    id: string;
    rule?: TransactionRuleType;
    transaction?: TransactionRecord;
    handleClose: (rule: TransactionRuleType) => void;
    isDrawerOverlay?: boolean;
    originalIsReviewed?: boolean | null;
  }) => {
    const props = {
      [ROOT_MODAL_PRESENTATION_PROP]: 'modal',
      rule,
      transaction,
      handleClose,
      isDrawerOverlay,
      originalIsReviewed,
    };
    return rootUiTypes.mkRootUiData({
      id,
      type: DIALOG_TYPE,
      allowNesting: true,
      props: ImmutableMap(props),
    });
  },
);
